<app-dialog class="invite-user-dialog" [loading]="isLoading">
  <ng-container dialog-title>
    {{ inviteUserDialogTitle }}
  </ng-container>
  <ng-container dialog-content>
    <mat-tab-group [(selectedIndex)]="tabIndex" [animationDuration]="0" [disableRipple]="true" (selectedTabChange)="tabChanged($event)">
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="tabs">
            <span class="step">1</span>
            <span>{{ 'module.modals.inviteWorker.userText' | translate }}</span>
          </div>
        </ng-template>
        <div class="tab-content">
          <div class="header-label">
            <span class="label">E-Mail Adresse </span>
            <div class="header-text">
              <span class="sub-text">{{ 'module.modals.inviteWorker.emailSearchSubPlaceholderText' | translate }}</span>
              <span class="sub-text">{{ 'module.modals.inviteWorker.emailHintText' | translate }}</span>
            </div>
          </div>
          <mat-form-field class="example-chip-list chip-list" *ngIf="!isEdit">
            <mat-chip-list #emailList aria-label="E-Mail Addresses">
              <mat-chip *ngFor="let user of userList; trackBy: trackByFnUser" [removable]="true" (removed)="remove(user)" class="chip">
                {{ user.email }}
                <span class="fa fa-times" aria-hidden="true" class="delete-icon"></span>
              </mat-chip>
              <div class="input-container">
                <input
                  title="email-input"
                  [matChipInputFor]="emailList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="add($event)"
                  (keydown)="emailInputChange($event)"
                  class="email-input"
                  autocomplete="off"
                />
                <mat-spinner *ngIf="isEmailVerifying" [diameter]="20" class="spinner" mode="indeterminate"> </mat-spinner>
              </div>
            </mat-chip-list>
          </mat-form-field>
          <div class="user-edit-email" *ngIf="isEdit">
            {{ data.user.email }}
          </div>
          <div class="err-msg" *ngIf="errorMsg.length > 0"><span class="fa fa-exclamation-circle"></span> {{ errorMsg }}</div>
          <div class="label">Rolle</div>
          <mat-form-field appearance="fill" class="role-dropdown">
            <mat-select [disableOptionCentering]="true" [disableRipple]="true" [(value)]="selectedRole" (selectionChange)="selectRole($event.value)">
              <mat-option *ngFor="let role of managedRoles; trackBy: trackByFnRoles" [value]="role">
                {{ role.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="systemID-table" *ngIf="isEdit && userSystemIdentities">
            <div class="label">Externe User IDs:</div>
            <table class="user-systemID">
              <thead>
                <tr>
                  <th *ngFor="let header of tableHeaders">{{ header.displayName }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of userSystemIdentities">
                  <td *ngFor="let header of tableHeaders">{{ data[header.key] }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="priv-rights" [disabled]="isDisablePrivilegeAccess" *ngIf="isShowPrivilegeAccessCheckbox">
            <span>
              <mat-checkbox
                class="checkbox"
                [disabled]="isDisablePrivilegeAccess"
                [checked]="isPrivAccessUser"
                (change)="isChecked($event.checked)"
              ></mat-checkbox>
            </span>
            <span class="priv-label" [ngClass]="isDisablePrivilegeAccess ? 'priv-rights-disabled' : ''"> Privilegierter Zugriff </span>
            <img
              appReusableTooltip
              [tooltip]="informationIconTooltipText"
              position="below"
              width="{{ isGemisTenant ? 350 : 310 }}"
              src="./assets/icons/info-circle-invite-edit.png"
              alt=""
            />
          </div>
        </div>
      </mat-tab>
      <mat-tab [disabled]="!isFirstTabComplete" *ngIf="!no2ndTabSelections">
        <ng-template mat-tab-label>
          <div class="tabs">
            <span class="step">2</span>
            <span>Kommunale Einstellungen</span>
          </div>
        </ng-template>
        <div class="tab-content">
          <div class="instruction-section">
            <span class="label label-title">Zuweisung </span>
            <span class="sub-text divider">| </span>
            <span class="sub-text location-placeholder-text"> {{ 'module.modals.inviteWorker.municipalityRegionSearchPlaceHolderText' | translate }}</span>
          </div>
          <div [ngClass]="this.isScrolling ? 'tree-box' : 'tree-box-scroll'">
            <app-list-tree
              #tree
              [data]="treeViewData"
              [multiple]="canSelectMultiple"
              (selectEvent)="checkIsFormComplete()"
              [itemSize]="10"
              (completeEvent)="treeViewComplete()"
            ></app-list-tree>
          </div>
        </div>
      </mat-tab>
      <mat-tab *ngIf="!isEdit">
        <div class="tab-content">
          <ng-template mat-tab-label>
            <div class="tabs">
              <span class="step">{{ no2ndTabSelections ? '2' : '3' }}</span>
              <span> {{ 'module.modals.inviteWorker.personalMessageText' | translate }} </span>
            </div>
          </ng-template>
          <br />
          <span class="sub-text">{{ 'module.modals.inviteWorker.optionalMessageText' | translate }}</span>
          <div>
            <textarea title="invite-note" #inviteNote rows="6" cols="89" maxlength="500"></textarea>
          </div>
          <span class="text-limit">{{ 'module.modals.inviteWorker.textLimit' | translate }}</span>
        </div>
      </mat-tab>
    </mat-tab-group>
  </ng-container>
  <ng-container dialog-actions>
    <button class="btn btn-outline-secondary" (click)="cancel()">Abbrechen</button>
    <button class="btn btn-outline-primary" (click)="tabIndex = 0" *ngIf="tabIndex === 1">Zurück</button>
    <button class="btn btn-outline-primary" (click)="tabIndex = 1" *ngIf="tabIndex === 0 && !no2ndTabSelections" [disabled]="!isFirstTabComplete">
      Weiter
    </button>
    <button class="btn btn-outline-primary" (click)="save()" *ngIf="!isEdit && isFormComplete">E-Mail senden</button>
    <button class="btn btn-outline-primary" (click)="update()" *ngIf="isEdit && isFormComplete && hasChanges">Update</button>
  </ng-container>
</app-dialog>
